import { render } from "./Zuowufenxi.vue?vue&type=template&id=8844e276&scoped=true"
import script from "./Zuowufenxi.vue?vue&type=script&lang=js"
export * from "./Zuowufenxi.vue?vue&type=script&lang=js"

import "./Zuowufenxi.vue?vue&type=style&index=0&id=8844e276&lang=less&scoped=true"

import exportComponent from "E:\\上蔡\\大数据\\窄版\\shancgai - 窄版\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8844e276"]])

export default __exports__